import React, { useContext } from 'react';
import { StoreContext } from '../../store';

import { isObjectEmpty } from '../../services';

const LimitModal = ({ isOpen, onClose, onLogin }) => {

  const { state, navigate } = useContext(StoreContext);
  const { userDetails } = state;

  const isLoggedIn = !isObjectEmpty(userDetails) && userDetails?.email;

  const includedPaths = ['/explore'];


  const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';

  if (!includedPaths.includes(currentPath) || !isOpen) return null;

  const handleButtonClick = () => {
    if (isLoggedIn) {
      navigate('/pricing');
    } else {
      navigate('/login');
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-md z-50">
      <div className="bg-white shadow-xl p-4 max-w-[400px] text-center">
        <h2 className="text-xl font-semibold text-gray-800 mb-3">
          Credit Limit Reached
        </h2>
        <p className="text-sm text-gray-600 mb-6">
          You've used up your {isLoggedIn ? '10' : '3'} free credits.
          {isLoggedIn ?
            ' Want unlimited access? Click here to view your pricing options.' :
            ' Want to keep exploring? Log in to continue using the app.'
          }
        </p>
        <div className="flex justify-center gap-3">
          <button
            onClick={() => handleButtonClick()}
            className="text-sm text-white px-4 py-2 bg-[#f1592a] transition"
          >
            {isLoggedIn ? 'Go to Pricing' : 'Log In'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default LimitModal;
